import React from 'react';
import { Trans } from '@lingui/macro';
import {
    TrendingUpOutlined,
    Group,
    Chip,
    useBreakpoint,
    Flex,
    Text,
} from '@landr/maestro';
import { useSearchModifiers } from 'controllers/SearchController/hooks/useSearchModifiers';
import { useApiFiltersContext } from 'contexts/ApiFiltersContext/ApiFiltersContext';
import { FiltersParams } from 'types/params';
import { InstrumentFamily } from 'types/enums';
import { ModifiersPayload } from 'controllers/SearchController/types';
import { Instruments } from 'types/enums/instruments';
import { Genres } from 'types/enums/genres';

const TrendingItem = ({ modifiers }: { modifiers: ModifiersPayload }) => {
    const { getFilterLabel } = useApiFiltersContext();
    const { addFilter } = useSearchModifiers();

    const [filter, slug] = modifiers;

    if (!slug) {
        return null;
    }

    const displayName = getFilterLabel(slug, filter).toLowerCase();

    return (
        <Chip
            isRounded
            size="sm"
            palette="subtle"
            onClick={() => addFilter([modifiers])}
            cursor="pointer"
        >
            {displayName}
        </Chip>
    );
};

const defaultTrendingSearches: ModifiersPayload[] = [
    [FiltersParams.instruments, InstrumentFamily.Vocals],
    [FiltersParams.instruments, InstrumentFamily.Drums],
    [FiltersParams.instruments, Instruments.EightHundredEight],
    [FiltersParams.genres, Genres.Trap],
    [FiltersParams.genres, Genres.Rnb],
    [FiltersParams.genres, Genres.House],
    [FiltersParams.genres, Genres.BoomBap],
];

export const InlineTrending = () => {
    const isMobile = useBreakpoint('ms');

    return (
        <Group
            paddingTop="md"
            gap="sm"
            justifyContent="center"
            alignItems="baseline"
            direction={isMobile ? 'vertical' : 'horizontal'}
        >
            <Group.Item>
                <Group gap="xs">
                    <Group.Item>
                        <TrendingUpOutlined color="icon.warning" size="sm" />
                    </Group.Item>
                    <Group.Item>
                        <Text fontSize="sm">
                            <Trans>Trending</Trans>
                        </Text>
                    </Group.Item>
                </Group>
            </Group.Item>
            <Group.Item>
                <Flex
                    flexWrap="wrap"
                    gap="xs"
                    style={{
                        position: 'relative',
                        overflow: 'hidden',
                        alignItems: 'flex-start',
                        alignContent: 'flex-start',
                    }}
                >
                    {defaultTrendingSearches.map((modifiers) => (
                        <TrendingItem
                            key={modifiers[0]}
                            modifiers={modifiers}
                        />
                    ))}
                </Flex>
            </Group.Item>
        </Group>
    );
};
